export const DASHBOARD_BASE = 'dashboard/DASHBOARD_BASE';
export const DASHBOARD_LOADING = 'dashboard/DASHBOARD_LOADING';
export const DASHBOARD_LOADED = 'dashboard/DASHBOARD_LOADED';
